<script>
import { format, addDays, parseISO } from 'date-fns';

export default {
	props: {
		default_label: {
			type: String,
			required: false
		},
		value: {
			required: false
		},
		disabled: {
			required: false
		}
	},
	methods: {
		click_tomorrow: function (evt) {
			this.selectedDate = this.tomorrow;
			this.selected();
		},
		click_fr: function (evt) {
			this.selectedDate = this.fr;
			this.selected();
		},
		click_empty: function (evt) {
			this.selectedDate = null;
			this.selected();
		},
		selected: function (env) {
			
			if (this.selectedDate) {
				if (this.selectedDate.getHours() === 21
					&& this.selectedDate.getMinutes() === 55
					&& this.selectedDate.getSeconds() === 0
					&& this.selectedDate.getMilliseconds() === 0) {
					this.title = 'V Franciji'
				} else {
					this.selectedDate.setUTCHours(0,0,0,0);
					if (this.selectedDate == this.tomorrow) this.title = 'JUTRI';
					else this.title = format(this.selectedDate, 'dd.MM.yyyy');
				}
			} else {
				this.title = 'Ni roka';
			}
			this.$emit('input', this.selectedDate);
			this.$refs.dropdown.hide();
		},
		selected1: function (env) {
			if (this.selectedDate && !this.is_custom) {
				this.is_smalltext_class = false;
				this.title = format(this.selectedDate, 'dd.MM.yyyy');
			}
			this.is_custom = false;
			if (this.selectedDate) {
				this.$emit('input', this.selectedDate.toISOString());
			}
			this.$emit('input', this.selectedDate);
			this.$refs.dropdown.hide();
		}
	},
	computed: {
		selectedTitle () {
			if (this.title) {
				return this.title;
			} else if (this.default_label) {
				return this.default_label;
			} else {
				return this.default_label_empty;
			}
		},
		tomorrow () {
			let today = new Date();
			today.setUTCHours(0,0,0,0);
			return addDays(today, 1);
		},
		fr () {
			let today = new Date();
			today.setUTCHours(20,55,0,0);
			return addDays(today, 14);
		}
	},
	data: function () {
		return {
			title: null,
			selectedDate: null,
			default_label_empty: 'Ni roka',
			is_custom: false
		}
	},
	created () {
	},
	mounted () {
		if (this.value) {
			this.selectedDate = parseISO(this.value);
			if (this.selectedDate.getHours() === 20
				&& this.selectedDate.getMinutes() === 55
				&& this.selectedDate.getSeconds() === 0
				&& this.selectedDate.getMilliseconds() === 0) {
				this.title = 'V Franciji';
			} else {
				this.selectedDate.setUTCHours(0,0,0,0);
				if (this.selectedDate.toISOString() == this.tomorrow.toISOString()) {
					this.title = 'JUTRI';
				}
			}
		}
	}
}
</script>
<template>
	<b-dropdown :disabled="disabled" variant="primary" :text="selectedTitle" ref="dropdown" class="estimatedDateInput">
		<b-dropdown-form class="date-dd">
			<b-row>
				<b-col sm="12" class="ml-2">
					<v-date-picker
						v-model="selectedDate"
						is-inline
						locale="sl-SI"
						@input="selected"/>
				</b-col>
			</b-row>
			<b-row>
				<b-col align-self="end" sm="4">
					<b-button variant="warning" class="ml-2 mt-2 t" size="sm" @click.prevent="click_tomorrow">Jutri</b-button>
				</b-col>
				<b-col align-self="center" sm="4">
					<b-button variant="info" class="mt-2 t" size="sm" @click.prevent="click_fr">V Franciji</b-button>
				</b-col>
				<b-col sm="4">
					<b-button variant="danger" class="mt-2 t" size="sm" @click.prevent="click_empty">Ni roka</b-button>
				</b-col>
			</b-row>
		</b-dropdown-form>
	</b-dropdown>
</template>
<style scoped>
.date-dd {
	width: 17rem!important;
}
.estimatedDateInput {
	width: 7rem;
	max-width: 7rem;
	min-width: 7rem;
}
</style>